import { getMobileAppUrl } from 'configs/mobileAppLinks';
import { useState, useEffect } from 'react';
import { isMobileOnly } from 'utils/device-detect';
import s from '../Header.module.scss';

export const ignorePromotionBannerKey = 'ignorePromotionBanner';
const usePromoBanner = ({ isMobilePromotionEnabled }: Props) => {
    const shouldIgnorePromotionBanner = sessionStorage.getItem(ignorePromotionBannerKey) === 'true';
    const link = getMobileAppUrl();
    const isInitiallyVisible =
        isMobilePromotionEnabled && isMobileOnly() && Boolean(link) && !shouldIgnorePromotionBanner;
    const [margin, setMargin] = useState(`${s.headerMarginBottom} ${isInitiallyVisible ? s.appPromotionOn : ''}`);
    const [isOpened, setOpened] = useState(isInitiallyVisible);
    const promoBannerCssHack = () => {
        document.body.classList[isOpened ? 'add' : 'remove']('promotion-banner-on');
    };
    const close = () => {
        setOpened(false);
        setMargin(s.headerMarginBottom);
        //TODO: set margin top of hamburger menu
        setOpened(false);
        sessionStorage.setItem(ignorePromotionBannerKey, 'true');
    };
    useEffect(promoBannerCssHack, [isOpened]);

    return {
        margin,
        isVisible: isOpened,
        link,
        close,
    };
};
export default usePromoBanner;

interface Props {
    isMobilePromotionEnabled?: boolean;
}
